import { useNavigate, Link } from 'react-router-dom';
import { LoginForm } from '../components/LoginForm';
import { 
  Title,
  Center,
  Image,
  Text,
  Group
} from '@mantine/core';

import studiocastLogo from '@/assets/studiocast_rbg_couleur.svg';
import { useTranslation } from 'react-i18next';
import { LanguageSwitch } from '@/components/Language/LanguageSwitch';

export const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '5vh 5vw',
          alignItems: 'center',
          position: 'fixed',
          bottom: '0px',
          top: '0px',
          width: '100%'

        }}>
          <div style={{
            padding: '10px',
            flexBasis: '50%'
          }}>
            <Center>
              <Image src={studiocastLogo} />
            </Center>
          </div>
          <div style={{
            padding: '10px',
            flexBasis: '50%'
          }}>
            <LanguageSwitch />
            <Title>{t('misc.welcomeStudiocast')}</Title>
            <LoginForm onSuccess={() => navigate('/') }/>
            <Group>
              <Link to={'/forgot-password'}>
                <Text>{t('password.forgotPassword')}</Text>
              </Link>
            </Group>
          </div>
        </div>
    </>
  );
};
